export const productosIndicadores = [
      {
        id: 604,
        categoria: 'indicadores',
        nombre: 'INDICADOR LP7516',
        descripcion: 'El indicador LP7516 es un equipo robusto y preciso, diseñado para aplicaciones industriales exigentes. ',
        descripcion2: 'Ofrece alta confiabilidad en la medición de peso, con pantalla LCD de fácil lectura, funciones de calibración simples y construcción resistente para un uso continuo. Ideal para básculas de plataforma',
        imagen: '/imagenes/productos/Indicadores/lp1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '• Indicador Carcasa ABS LED Y LCD.',
              '• Opción BLUETOOTH 	',
              '• Opción chequeador HI / LO / OK',
              '• Pesaje animales, cuenta piezas. Acumulación de pesadas, HOLD, PEK ',
              '• Display 6 dígitos LCD, LED 1”.',
              '• 1/40.000, 40 c/Seg. ',
              '• RS232, Unidades kg, g, lb, oz'
            ]
          }
        ],
        opciones: [
          {
            id: 'lp75',
            nombre: 'LP7516',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/lp1.webp',
          '/imagenes/productos/Indicadores/lp2.webp',

        ]
      },
      {
        id: 605,
        categoria: 'indicadores',
        nombre: 'INDICADOR PC-200',
        descripcion: 'El indicador PC200 es un equipo robusto y confiable, maneja puntos de corte por rele',
        descripcion2: 'Este equipo robusto y confiable, maneja puntos de corte por rele; entornos industriales exigentes. Su construcción resistente y su electrónica precisa garantizan un rendimiento estable y duradero, incluso en condiciones de trabajo intensivas.',
        imagen: '/imagenes/productos/Indicadores/pc1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	PC200 Pantalla LCD de 6 dígitos del 1"21 y las indicaciones de estado.',
              '•	La interfaz: 2 RS232 se puede conectar la impresora, monitor remoto de PC, por separado.',
              '•	Unidades: Kg Lb; oz; g',
              '•	Fuente de alimentación AC 220~240V (110V opcional) 50/60Hz; batería recargable incorporada 6V 4AH.',
              '•	Claves: 0-9 teclas numéricas (combinación de teclas de función) y 3 teclas de función',
              '•	Conexión de la célula de carga hasta 8 a 350 ohmios.',
              '•	Ampliar opcional: 3 puntos de control de salida RELE '
            ]
          }
        ],
        opciones: [
          {
            id: 'pc200',
            nombre: 'PC-200',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/pc1.webp',

        ]
      },
      {
        id: 606,
        categoria: 'indicadores',
        nombre: 'INDICADOR XK-3119WP/M',
        descripcion: 'El indicador XK-3119WP está fabricado en acero inoxidable y cuenta con protección contra el agua, ',
        descripcion2: 'El indicador XK-3119WP  ideal para entornos industriales húmedos o de limpieza frecuente. Su diseño robusto y su pantalla clara aseguran lecturas precisas y confiables, incluso en condiciones exigentes, siendo perfecto para la industria alimentaria, pesquera y química.',
        imagen: '/imagenes/productos/Indicadores/xk1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Estructura completamente en Acero Inoxidable',
              '•	Protección IP67 Certificada',
              '•	15.000 Resoluciones (40 conversiones x segundo) Pesaje Estanques, Pesaje de Animales',
              '•	Comunicación RS-232, Chequeo HI / LO / OK Alerta sonora. Múltiples opciones de peso (kg, lb, oz, pcs)',
              '•	Acumulación de datos (peso & conteo)',
              '•	LCD Display con auto backligth, Hasta 4 celdas',
              '•	Auto apagado Opcional programable',
              '•	Hasta 4 celdas de 350 Ω',
              '•	Operación 220 Volt Adaptador y batería interna 6V.'

            ]
          }
        ],
        opciones: [
          {
            id: 'xk3119wp',
            nombre: 'XK-3119WP/M',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/xk1.webp',
          '/imagenes/productos/Indicadores/xk2.webp',

        ]
      },
      {
        id: 607,
        categoria: 'indicadores',
        nombre: 'TRANCELL TI-500E/SS',
        descripcion: 'El indicador Trancell TI-500E/SS es un equipo confiable de origen estadounidense, disponible en versión plástica ABS o en acero inoxidable ',
        descripcion2: 'Este indicador Ofrece alta precisión, durabilidad y facilidad de uso, ideal para aplicaciones de pesaje en diversos entornos productivos.',
        imagen: '/imagenes/productos/Indicadores/ti1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Indicador de peso Digital, NTEP 30.000 div.',
              '•	Puerto Serial FULL DUPLEX RS-232C Visor',
              '•	Display LED, 6 dígitos de 0,6"',
              '•	Función de Peso Kilos / Libras',
              '•	Teclado Zero, tara, NET/GROSS',
              '•	Versión plástico y full inoxidable.',
              '•	Interfase bidireccional RS-232, para conexión a computadora o impresora',
              '•	Funciona con corriente AC/DC y tiene batería recargable incorporada.(OPCIONAL)'
            ]
          }
        ],
        opciones: [
          {
            id: 'ti500plastico',
            nombre: 'VERSIÓN PLASTICO ABS',
            
          },
          {
            id: 'ti500inox',
            nombre: 'VERSIÓN INOXIDABLE',
            
          },

        ],
        imagenes: [
          '/imagenes/productos/Indicadores/ti1.webp',
          '/imagenes/productos/Indicadores/ti2.webp',
          '/imagenes/productos/Indicadores/ti3.webp',

        ]
      },
      {
        id: 608,
        categoria: 'indicadores',
        nombre: 'INDICADOR LP7510',
        descripcion: 'El indicador LP7510 inoxidable es un equipo robusto y preciso, fabricado en acero inoxidable para máxima resistencia en entornos industriales exigentes.',
        descripcion2: 'Ofrece alta confiabilidad en la medición de peso, con pantalla de fácil lectura, funciones simples de calibración y diseño duradero, ideal para uso continuo en la industria.',
        imagen: '/imagenes/productos/Indicadores/lp71.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Modelo: LP-7510',
              '•	Material de la carcasa: Acero Inoxidable',
              '•	Pantalla: LED de 6 dígitos',
              '•	6 celdas 350 OHM-12 de 700 ohm',
              '•	Ambiente de trabajo: -10ºC ~ +40ºC, ≤85%Rh',
              '•	Entrada RS-232: Si',
              '•	Comunicación Opcionales : Relé,  4-20mA',
              '•	Fuente de alimentación: AC110/220V 50/60Hz',
              '•	Batería de plomo 6V, 4ah o batería de Litio de 7.4 V 4 AH.'
            ]
          }
        ],
        opciones: [
          {
            id: 'lp7510',
            nombre: 'LP7510',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/lp71.webp',
          '/imagenes/productos/Indicadores/lp72.webp',
          '/imagenes/productos/Indicadores/lp73.webp',

        ]
      },
      {
        id: 609,
        categoria: 'indicadores',
        nombre: 'CAS CI200/SS',
        descripcion: 'La CAS CI-200 es una familia de indicadores digitales para básculas que ofrecen versatilidad y fiabilidad a un precio económico.',
        descripcion2: 'Estos indicadores están disponibles en diferentes modelos, incluyendo el CI-200A (carcasa de plástico NEMA 12) y el CI-200SC (carcasa de acero inoxidable 304 con clasificación IP67), entre otros. Son adecuados para diversas aplicaciones, desde operaciones estáticas de pesaje hasta entornos industriales húmedos y exigentes.  ',
        imagen: '/imagenes/productos/Indicadores/ci1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Estructura Plástica o en acero inoxidable de alta resistencia. ',
              '•	 Velocidad de 80 m/seg. ',
              '•	Teclado numérico programable. ',
              '•	Display LED/LCD con Auto BackLigth',
              '•	  Acumulación de Peso y Conteo. ',
              '•	 Múltiples opciones de peso : kg, lb ',
              '•	Display de lectura clara en ángulos amplios',
              '•	 Auto apagado Opcional programable ',
              '•	 Salida serial 232 y USB.'
            ]
          }
        ],
        opciones: [
          {
            id: 'ci200-led',
            nombre: 'LED',
            
          },
          {
            id:'ci200-lcd',
            nombre: 'LCD',
            
          },
          {
            id:'ci200-inox',
            nombre: 'INOXIDABLE',
          }
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/ci1.webp',
          '/imagenes/productos/Indicadores/ci2.webp',
          '/imagenes/productos/Indicadores/ci3.webp',

        ]
      },   
      {
        id: 610,
        categoria: 'indicadores',
        nombre: 'LAUMAS W100',
        descripcion: 'El indicador W100 es el más compacto de la línea, con solo 96 x 48 x 130 mm, ofreciendo todas las funciones de un indicador de peso completo',
        descripcion2: 'Su diseño para montaje en panel, conforme a estándares internacionales, lo hace ideal para cualquier sector industrial, destacando en sistemas de control para hormigonado, asfaltos, alimentación y químico-farmacéutico.',
        imagen: '/imagenes/productos/Indicadores/w1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Montaje en panel',
              '•	Display LED rojo de 6 dígitos de 14 mm',
              '•	Puertos RS232 y RS485 (Modbus RTU/protocolo ASCII Laumas)',
              '•	3 entradas lógicas, 5 salidas lógicas de relé',
              '•	Aprobado OIML R76:2006, clase III, 10000 divis. 0.2μV/VSI',
              '•	Aprobado OIML R61 - WELMEC 8.8:2011 (M.I.D.)',
              '•	Convertidor A/D 24 bit (16000000 puntos) 4.8 kHz',
              '•	Divisiones de lectura 999999',
              '•	Salida analógica 16 bits: 0/4-20 mA; 0-5/10 V; ±5/10 V (OPCIONAL)'
            ]
          }
        ],
        opciones: [
          {
            id: 'w100',
            nombre: 'LAUMAS W100',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/w1.webp',


        ]
      },
      {
        id: 611,
        categoria: 'indicadores',
        nombre: 'LAUMAS TLB',
        descripcion: 'El transmisor Laumas TLB es compacto y eficiente, diseñado para montaje trasero en barra Omega/DIN',
        descripcion2: 'Su formato vertical ahorra espacio, la pantalla LED roja asegura una lectura rápida y maneja todos los principales protocolos de comunicación industrial. Ideal para optimizar sistemas de pesaje en espacios reducidos.',
        imagen: '/imagenes/productos/Indicadores/tlb1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Puerto RS485 (Modbus RTU/protocolo ASCII Laumas)',
              '•	2 entradas lógicas, 3 salidas lógicas de relé',
              '•	Aprobado OIML R76:2006, clase III, 10000 divis. 0.2μV/VSI',
              '•	Aprobado OIML R61 - WELMEC 8.8:2011 (M.I.D.)',
              '•	Montaje en barra Omega/DIN en la parte trasera del panel',
              '•	Convertidor A/D 24 bit (16000000 puntos) 4.8 kHz',
              '•	Divisiones de lectura 999999',
              '•	Opcion de bus de campo: Profibus-DP  DeviceNet  Ethernet Modbus-TCP  EtherNet/IP; ProfiNet.'
            ]
          }
        ],
        opciones: [
          {
            id: 'laumas-tlb',
            nombre: 'LAUMAS TLB',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/tlb1.webp',
          '/imagenes/productos/Indicadores/tlb2.webp',

        ]
      },
      {
        id: 612,
        categoria: 'indicadores',
        nombre: 'SUPMETER: BST 106 PANEL',
        descripcion: 'El SUPMETER BST-106 Panel está diseñado para montaje en panel, ofreciendo alta confiabilidad en entornos industriales. ',
        descripcion2: 'Incorpora dos puntos de corte, función de tara y cuerpo con protección anti interferencias, además de dos puertos seriales y salida analógica, garantizando un rendimiento estable y preciso en el pesaje.',
        imagen: '/imagenes/productos/Indicadores/bt1panel.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	 Diseño EMC con alta capacidad anti interferencia, adecuado para entornos industriales.',
              '•	 2 relé con contactos normalmente abiertos y normalmente cerrados para emitir una señal de alarma de límite superior e inferior.',
              '•	 CPU ARM de 32 bits con reloj de 48MHz y mayor velocidad aritmética.',
              '•	 Módulo de conversión A/D de alta precisión y alta velocidad de 24 bits con resolución frecuencia de muestreo de 1220 Hz.',
              '•	 Operación en modo de menú y acceso directo.',
              '•	 Algoritmo especial de filtrado digital antivibración para garantizar la estabilidad y precisión del pesaje cuando hay una fuerte vibración en el receptor de carga, y la capacidad de respuesta rápida cuando cambia la señal de peso.',
              '•	 1 Salida de señal analógica opcional y definible [AO: 0~20mA].'

            ]
          },
          {
            titulo: 'Comunicaciones',
            items: [
                '•	RS232 continuo ModbusRTu',
                '•	RS485 ModbusRTU',
                '•	Ethernet Modbus-TCP'
            ]
          }
        ],
        opciones: [
          {
            id: 'bst106panel',
            nombre: 'BST-106 PANEL',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/bt1panel.webp',
          '/imagenes/productos/Indicadores/bt2panel.webp',
          '/imagenes/productos/Indicadores/bt3panel.webp',

        ]
      },
      {
        id: 613,
        categoria: 'indicadores',
        nombre: 'INDICADOR PROGRAMABLE BST-106',
        descripcion: 'El indicador programable BST es totalmente configurable según los requerimientos del cliente, compatible con la mayoría de los protocolos del mercado industrial ',
        descripcion2: 'Este indicador con opción de integrar PLC para mayor funcionalidad. Completamente confiable y probado en la gran industria nacional, garantiza precisión y rendimiento superior.',
        imagen: '/imagenes/productos/Indicadores/bt1programable.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                '•	Pantalla: TFT 7″ con panel táctil',
                '•	Sistema operativo: Propietario editable ',
                '•	Programación: Totalmente programable según requerimientos del cliente',
                '•	Alimentación: 5 VDC',
                '•	Hasta 8 celdas de 350 ohm',
                '•	Hasta 16 celdas de 700 ohm'
            ]
          },
          {
            titulo: 'Puertos de comunicación',
            items: [
                '•	1 × USB',
                '•	1 × RS232',
                '•	1 × Ethernet (LAN)'
            ]
          },
          {
            titulo: 'Opcionales',
            items: [
                '•	Display remoto',
                '•	Comunicación con PLC serie FX de Mitsubishi vía protocolo Ladder'
            ]
          }
        ],
        opciones: [
          {
            id: 'bst-programable',
            nombre: 'BST-106 PROGRAMABLE',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/bt1programable.webp',
          '/imagenes/productos/Indicadores/bt2programable.webp',

        ]
      },
      {
        id: 614,
        categoria: 'indicadores',
        nombre: 'BST-106 RIEL',
        descripcion: 'El SUPMETER BST-106 Riel está diseñado para montaje en riel DIN, ofreciendo máxima confiabilidad para la industria. ',
        descripcion2: 'Cuenta con dos puertos seriales, salida analógica y un rendimiento estable que lo convierte en un verdadero “caballo de batalla” para aplicaciones de pesaje industrial.',
        imagen: '/imagenes/productos/Indicadores/bt1riel.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                '•	Display: Doble línea de LED rojos, muestra peso y menú ',
                '•	Capacidad configurable: 1 a 99,999',
                '•	División: 1, 2, 5, 10, 20, 50, 100, 200, 500 ',
                '•	Resolución: hasta 1/50,000',
                '•	Tiempo de actualización: ajustable de 0.01 a 1.00 s',
                '•	Teclado: Teclado numérico inglés de 4 teclas para menú y accesos directos',
                '•	Excitación: 5 VDC / 120 mA (hasta 8 celdas de carga de 350 Ω)',
                '•	Entrada de señal: 0~12.5 mV',
                '•	Sensibilidad: 1.0~2.5 mV/V',
                '•	Frecuencia de muestreo: Seleccionable (5 a 3200 Hz)',
                '•	Conversión A/D: 24 bits sigma-delta',
                '•	3 entradas (normalmente abiertas, configurables)',
                '•	3 salidas transistor (normalmente abiertas, configurables)',
                '•	Corriente: 0~20 mA',
                '•	Voltaje: 0~10 V',
                '•	COM1: RS232 (modo continuo o Modbus RTU para display remoto)',
                '•	COM2: RS485 (Modbus RTU)',
                '•	COM3: CANBUS (opcional)',
                '•	Compatibilidad: Conexión con PC industrial (IPC), PLC, y displays remotos LED',

            ]
          }
        ],
        opciones: [
          {
            id: 'BST-106RIEL',
            nombre: 'BST-106 RIEL',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Indicadores/bt1riel.webp',
          '/imagenes/productos/Indicadores/bt2riel.webp',

        ]
      },
]; 